<template>
	<div>
		<firstsceenimage :imgobj='bigimage'></firstsceenimage>
		<adword title="权威专业的数字化版权保护机制"
			subtitle="星链通过人工智能和数据挖掘领域的前沿技术，从国内外主流时尚平台及社交平台挖掘时尚素材。从时尚素材收集、流行趋势发现，到新款式研发、爆款商品预测，为品牌商与平台客户实现从趋势发现、设计师款式选择、样品制作、品牌选样到柔性订单生产的全链路闭环。"
			slotheight="350" :subtitlestyle="subtitlestyle">
			<div>
				<div class="flexcenter" style="margin-top: 80px;">
					<div style="width: 280px;padding:  25px;">
						<img style="width: 85px;" src="../../static/区块链司法存证ico.png">
						<div style="font-weight: bold;font-size: 16px;letter-spacing: 4px;">司法存证</div>
						<div style="color: #999999; font-size: 12px;margin-top: 9px;">
							基于国家授时中心的时间标签区块链不可篡改的及时存证直通互联网法院、司法部门</div>
					</div>
					<div style="width: 280px;padding:  25px;">
						<img style="width: 85px;" src="../../static/版权登记ico.png">
						<div style="font-weight: bold;font-size: 16px;letter-spacing: 4px;">版权登记</div>
						<div style="color: #999999; font-size: 12px;margin-top: 9px;">司法存证和发表依据提供一站式版本登记与时尚版本保护方案</div>
					</div>
					<div style="width: 280px;padding:  25px;">
						<img style="width: 85px;" src="../../static/司法取证ico.png">
						<div style="font-weight: bold;font-size: 16px;letter-spacing: 4px;">司法取证</div>
						<div style="color: #999999; font-size: 12px;margin-top: 9px;">取证和举证证据直接上链在线司法处理证据直通互联网法院</div>
					</div>
					<div style="width: 280px;padding:  25px;">
						<img style="width: 85px;" src="../../static/版权监测ico.png">
						<div style="font-weight: bold;font-size: 16px;letter-spacing: 4px;">版权监测</div>
						<div style="color: #999999; font-size: 12px;margin-top: 9px;">专业人工智能查验和大数据分析筛查提前识别版本侵权风险和高效维权
						</div>
					</div>
				</div>
			</div>
		</adword>

		<!-- 小屏不搞动画 -->
		<adword v-if="!isShowNavAD" title="一站式时尚版权保护服务" subtitle="" slotheight="590">
			<div class="flexcenter">
				<div>
					<div style="position:relative; text-align: left;color: white;">
						<div v-show="swimgbool[0]" class="textbig" style="overflow:hidden;position :absolute; ">
							<div style="width: 100%;height: 30px;">
								全链条司法
							</div>
						</div>
						<div class="subtextbig" v-show="swimgbool[0]"
							style="color: #FEFEFE; width:  100%;height: 50px;overflow:hidden;position :absolute;opacity: 0.5;">
							<div style="width: 70%;height: 50px;line-height: 24px;font-size: 12px;">
								打通数字穿衣、版权发布、云授权、分享传播、渠道分销、消费终端互动等全链条的版权司法存证和版权保护服务
							</div>
						</div>

					</div>
					<img :class="[swimgbool[0]?'imgbig':'imgsmall']" style="width: 100%;" :src="img[0]">
				</div>

				<div>
					<div style="position:relative; text-align: left;color: white;">

						<div v-show="swimgbool[1]" class="textbig" style="overflow:hidden;position :absolute; ">
							<div style="width: 100%;height: 30px;">
								平台专业服务
							</div>
						</div>



						<div v-show="swimgbool[1]" class="subtextbig" 
							style=" color: #FEFEFE; width:  100%;;height: 50px;overflow:hidden;position :absolute;opacity: 0.5;">
							<div style="width:  70%;;height: 50px;line-height: 24px;font-size: 12px;">
								为时尚企业和个人设计师提供版权存证、
								版权一站式登记、侵权检测、侵权取证、
								司法服务等全面的专业服务
							</div>
						</div>

					</div>


					<img @mouseover.stop="swimg(1)" :class="[swimgbool[1]?'imgbig':'imgsmall']" style="width: 100%;"
						:src="img[1]">
				</div>

				<div>
					<div style="position:relative; text-align: left;color: white;">
						<div v-show="swimgbool[2]" class="textbig" style="overflow:hidden;position :absolute; ">
							<div style="width: 100%;height: 30px;">
								聚焦时尚
							</div>
						</div>

						<div v-show="swimgbool[2]" class="subtextbig" 
							style=" color: #FEFEFE; width: 100%;height: 50px;overflow:hidden;position :absolute;opacity: 0.5;">
							<div style="width:  70%;;height: 50px;line-height: 24px;font-size: 12px;">
								聚焦鞋服箱包、美妆、钟表、
								珠宝、家居、电子、眼镜等时尚产业
								有关的数字创意和时尚版权保护
							</div>
						</div>
					</div>


					<img @mouseover.stop="swimg(2)" :class="[swimgbool[2]?'imgbig':'imgsmall']" style="width: 100%;"
						:src="img[2]">
				</div>


			</div>
		</adword>


		<adword v-if="isShowNavAD" title="一站式时尚版权保护服务" subtitle="" slotheight="590">
			<div class="flexcenter">
				<div>
					<div style="position:relative; text-align: left;color: white;">
						<transition name="wordshow">
							<div v-show="swimgbool[0]" class="textbig" style="overflow:hidden;position :absolute; ">
								<div style="width: 100%;height: 30px;">
									全链条司法
								</div>
							</div>
						</transition>
						<transition name="wordshow">
							<div v-show="!swimgbool[0]" class="textsmall" style="overflow:hidden;position :absolute; ">
								<div style="width: 40px;height: 500px;">
									全链条司法
								</div>
							</div>
						</transition>
						<transition name="wordfade">
							<div v-show="swimgbool[0]"
								style="top:430px;left: 50px; color: #FEFEFE; width: 100%;height: 50px;overflow:hidden;position :absolute;opacity: 0.5;">
								<div style="width: 100%;height: 50px;line-height: 24px;font-size: 12px;">
									打通数字穿衣、版权发布、云授权、分享传播、渠道分销、消费终端互动等全链条的版权司法存证和版权保护服务
								</div>
							</div>
						</transition>
					</div>


					<img @mouseover.stop="swimg(0)" :class="[swimgbool[0]?'imgbig':'imgsmall']" style="height: 540px;"
						:src="img[0]">
				</div>

				<div>
					<div style="position:relative; text-align: left;color: white;">
						<transition name="wordshow">
							<div v-show="swimgbool[1]" class="textbig" style="overflow:hidden;position :absolute; ">
								<div style="width: 100%;height: 30px;">
									平台专业服务
								</div>
							</div>
						</transition>
						<transition name="wordshow">
							<div v-show="!swimgbool[1]" class="textsmall" style="overflow:hidden;position :absolute; ">
								<div style="width: 40px;height: 500px;">
									平台专业服务
								</div>
							</div>
						</transition>
						<transition name="wordfade">
							<div v-show="swimgbool[1]"
								style="top:430px;left: 50px; color: #FEFEFE; width: 100%;height: 50px;overflow:hidden;position :absolute;opacity: 0.5;">
								<div style="width: 100%;height: 50px;line-height: 24px;font-size: 12px;">
									为时尚企业和个人设计师提供版权存证、
									版权一站式登记、侵权检测、侵权取证、
									司法服务等全面的专业服务
								</div>
							</div>
						</transition>
					</div>


					<img @mouseover.stop="swimg(1)" :class="[swimgbool[1]?'imgbig':'imgsmall']" style="height: 540px;"
						:src="img[1]">
				</div>

				<div>
					<div style="position:relative; text-align: left;color: white;">
						<transition name="wordshow">
							<div v-show="swimgbool[2]" class="textbig" style="overflow:hidden;position :absolute; ">
								<div style="width: 100%;height: 30px;">
									聚焦时尚
								</div>
							</div>
						</transition>
						<transition name="wordshow">
							<div v-show="!swimgbool[2]" class="textsmall" style="overflow:hidden;position :absolute; ">
								<div style="width: 40px;height: 500px;">
									聚焦时尚
								</div>
							</div>
						</transition>
						<transition name="wordfade">
							<div v-show="swimgbool[2]"
								style="top:430px;left: 50px; color: #FEFEFE; width: 100%;height: 50px;overflow:hidden;position :absolute;opacity: 0.5;">
								<div style="width: 100%;height: 50px;line-height: 24px;font-size: 12px;">
									聚焦鞋服箱包、美妆、钟表、
									珠宝、家居、电子、眼镜等时尚产业
									有关的数字创意和时尚版权保护
								</div>
							</div>
						</transition>
					</div>


					<img @mouseover.stop="swimg(2)" :class="[swimgbool[2]?'imgbig':'imgsmall']" style="height: 540px;"
						:src="img[2]">
				</div>


			</div>
		</adword>

		<advideo style="color: white;" title="登记司法维权全流程" viewheight="200" :video="video"> </advideo>
	</div>
</template>
<script>
	import firstsceenimage from '../../components/firstsceenimage.vue'
	import adword from '../../components/adword.vue'
	import bigimage from '../../static/banner3.png'
	import advideo from '../../components/advideo.vue'
	import video from '../../assets/video/1.mp4'

	export default {
		name: 'Prodatapr',
		components: {
			firstsceenimage,
			adword,
			advideo,
		},
		data() {
			return {
				isplay: false, //控制重提的动效 避免重复

				bigimage: bigimage,
				video: video,
				subtitlestyle: {
					fontSize: '14px',
					color: '#666666',
					lineHeight: '28px',
				},

				swimgbool: [true, false, false],
				swimgbool2: [true, false, false],
				img: [require('../../static/全链条司法p.png'),
					require('../../static/平台专业服务p2.png'),
					require('../../static/聚焦时尚p2.png')
				],
				isShowNavAD: true,
			}

		},
		mounted() {
			if (window.innerWidth < 1000) {
				this.isShowNavAD = false
			}

			if (window.innerWidth < 1400) {
				this.$set(this.swimgbool, 0, true)
				this.$set(this.swimgbool, 1, true)
				this.$set(this.swimgbool, 2, true)


				this.$set(this.img, 1, require('../../static/平台专业服务p.png'))
				this.$set(this.img, 2, require('../../static/聚焦时尚p.png'))
			}

		},
		methods: {
			swimg: function(index) {
				if (this.swimgbool[index]) {
					return
				}
				//防止动画过程中重复执行会出现闪烁
				if (this.isplay) {

					return;
				}

				this.isplay = true;
				var _this = this
				setTimeout(() => {
					_this.isplay = false
				}, 400);
				//防止动画过程中重复执行会出现闪烁-end
				for (var i = 0; i < 3; i++) {
					if (index == i) {
						if (!this.swimgbool[index]) {
							this.$set(this.swimgbool, index, true)
						}
					} else {
						this.$set(this.swimgbool, i, false)
					}
				}

				this.img = []
				if (this.swimgbool[0]) {

					this.img[0] = require('../../static/全链条司法p.png')
				} else {

					this.img[0] = require('../../static/全链条司法p2.png')
				}

				if (this.swimgbool[1]) {

					this.img[1] = require('../../static/平台专业服务p.png')
				} else {

					this.img[1] = require('../../static/平台专业服务p2.png')
				}
				if (this.swimgbool[2]) {

					this.img[2] = require('../../static/聚焦时尚p.png')
				} else {

					this.img[2] = require('../../static/聚焦时尚p2.png')
				}



			}
		}

	}
</script>

<style>
	.wordfade-enter-active {
		animation: wordfade-in 1s;
	}

	@keyframes wordfade-in {
		0% {
			opacity: 0;
			width: 0px;
		}

		100% {

			opacity: 0.5;
		}
	}

	.wordshow-enter-active {
		animation: wordshow-in 1s;

	}

	@keyframes wordshow-in {
		0% {
			opacity: 0;
			width: 0px;
		}



		100% {

			opacity: 1;
		}
	}

	@media (min-width: 1px) {

		.textbig {
			top: 120px;
			left: 20px;
			width: 100%;
			height: 30px;
			letter-spacing: 6px;
			font-size: 25px;
			font-weight: bold;
		}

		.subtextbig {
			top:180px;
			left: 20px; 
		}
	}

	@media (min-width: 1000px) {

		.textbig {
			top: 370px;
			left: 50px;
			width: 500px;
			height: 30px;
			letter-spacing: 6px;
			font-size: 25px;
			font-weight: bold;
		}

		.subtextbig {
			top:430px;
			left: 50px; 
		}
	}

	.textsmall {
		top: 90px;
		left: 95px;
		line-height: 260%;

		font-size: 25px;
		font-weight: bold;
		width: 40px;
		height: 500px;


	}



	.imgbig {
		width: 943px;
		animation-name: imgbigdraw;
		animation-duration: 1s;
	}

	.imgsmall {
		width: 223.9px;
		animation-name: imgsmalldraw;
		animation-duration: 1s;
	}

	@keyframes imgbigdraw {
		0% {
			width: 223.9px;
		}

		100% {
			width: 943px;
		}
	}

	@keyframes imgsmalldraw {
		0% {
			width: 943px;
		}

		100% {
			width: 223.9px;
		}
	}
</style>
